import Decimal from 'break_eternity.js';

export { Decimal };
export type D = Decimal;

export const ZERO = new Decimal(0);
export const ONE = new Decimal(1);

export function d(v: number | string | Decimal): Decimal {
  if (v instanceof Decimal) return v;
  return new Decimal(v);
}

const SUFFIX = [
  '',
  'K',
  'M',
  'B',
  'T',
  'aa',
  'ab',
  'ac',
  'ad',
  'ae',
  'af',
  'ag',
  'ah',
  'ai',
  'aj',
];

/** Compact human-friendly format. Numbers < 1000 keep decimals. */
export function fmt(v: Decimal | number, digits = 2): string {
  const dec = v instanceof Decimal ? v : new Decimal(v);
  if (dec.lt(0)) return '-' + fmt(dec.neg(), digits);
  if (dec.lt(1000)) {
    const n = dec.toNumber();
    if (Number.isInteger(n) || n >= 100) return Math.floor(n).toString();
    return n.toFixed(digits).replace(/\.?0+$/, '');
  }
  const exp = Math.floor(dec.log10().toNumber());
  const tier = Math.floor(exp / 3);
  if (tier < SUFFIX.length) {
    const mantissa = dec.div(new Decimal(10).pow(tier * 3));
    return mantissa.toNumber().toFixed(digits).replace(/\.?0+$/, '') + SUFFIX[tier];
  }
  // Fall back to scientific.
  return dec.toExponential(digits);
}

/** Format an integer count (no decimals). */
export function fmtInt(v: Decimal | number): string {
  const dec = v instanceof Decimal ? v : new Decimal(v);
  if (dec.lt(1000)) return Math.floor(dec.toNumber()).toString();
  return fmt(dec, 1);
}

/** Format Φ with a tight monospace style — always integer until thousands. */
export function fmtPhi(v: Decimal | number): string {
  const dec = v instanceof Decimal ? v : new Decimal(v);
  if (dec.lt(10000)) return Math.floor(dec.toNumber()).toString();
  return fmt(dec, 2);
}
